import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import ResultPage from '@blade-sxp/data-mining/components/result-page.vue';
import { getAllTaskList } from '@blade-sxp/data-mining/apis/index';
let default_1 = class default_1 extends Vue {
    searchInput;
    fileNameVisible;
    loading;
    title;
    imgList;
    task;
    sliderValue = 0;
    imgUrl = require('@blade-sxp/data-mining/assets/images/1.png');
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    input4 = '';
    cardList = '';
    disabled = true;
    isChecked = true;
    isClose = true;
    searchDisabled = true;
    form = {
        taskVal: '',
        input: '',
    };
    taskList = [];
    timeout = 0;
    isClosed(val) {
        if (val) {
            this.isClose = !this.isClose;
            this.disabled = true;
        }
    }
    async mounted() {
        await this.initData();
        this.form.taskVal = this.task;
        this.form.input = this.searchInput;
        if (this.form?.taskVal && this.form?.input) {
            this.changeName(this.form);
        }
    }
    initData() {
        const param = {
            taskTypes: ['REALTIME_CLUSTER'],
        };
        getAllTaskList(param).then((res) => {
            this.taskList = res;
        });
    }
    getName(val) {
        if (val) {
            return val;
        }
        return this.$t('name');
    }
    previous() {
        this.$emit('previous');
    }
    handleClose() {
        this.$emit('close');
        this.isChecked = !this.isChecked;
        this.input4 = '';
    }
    changeList(val) {
        if (val) {
            this.disabled = false;
            this.cardList = val;
        }
        else {
            this.disabled = true;
        }
    }
    save() {
        this.$emit('data', this.cardList);
    }
    changeName(val) {
        window.clearTimeout(this.timeout);
        this.timeout = window.setTimeout(() => {
            if (val.input.length) {
                this.$emit('change-name', val);
            }
        }, 300);
    }
};
__decorate([
    Prop({ default: '' })
], default_1.prototype, "searchInput", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "fileNameVisible", void 0);
__decorate([
    Prop({ default: false })
], default_1.prototype, "loading", void 0);
__decorate([
    Prop()
], default_1.prototype, "title", void 0);
__decorate([
    Prop()
], default_1.prototype, "imgList", void 0);
__decorate([
    Prop()
], default_1.prototype, "task", void 0);
__decorate([
    Watch('fileNameVisible')
], default_1.prototype, "isClosed", null);
default_1 = __decorate([
    Component({
        name: 'fileName',
        components: { BlurPicture, ResultPage },
        i18n: {
            messages: {
                en: {
                    similarity: 'Similarity',
                    save: 'Save',
                    cancel: 'Cancel',
                    portraits: 'Portraits',
                    name: 'Anonymous',
                    placeholderTask: 'Please select file cluster task',
                    pleaseInput: 'Please input',
                },
                zh: {
                    pleaseInput: '请输入内容',
                    similarity: '相似度',
                    save: '保存',
                    cancel: '取消',
                    portraits: '人像库',
                    name: '未知身份',
                    placeholderTask: '请选择聚档任务',
                },
            },
        },
    })
], default_1);
export default default_1;
